const Words=[
  {
    word:"I",
    sentence:"I am Batman!"
  },
  {
    word:"to",
    sentence:"I want to eat!"
  },
  {
    word:"for",
    sentence:"I need pencils for school. "
  },{
    word:"they",
    sentence:"They played football."
  },
  {
    word:"or",
    sentence:"Pie or ice cream?"
 
  },
  {
    word:"can",
    sentence:"I can run fast."
  },{
  word:"here",
  sentence:"Is Mom here?"
},{
word:"see",
sentence:"I see the dog. "
},
  {
    word:"play",
    sentence:"I want to play baseball."
  },
  {
    word:"come",
    sentence:"Will Iron Man come?"
  },
  {
    word:"the",
    sentence:"Can I have the ball?"
  },
  {
    word:"is",
    sentence:"This is fun!"
  },{
    word:"are",
    sentence:"We are hungry."
  },
  {
    word:"be",
    sentence:"I will be a witch for Halloween."
 
  },
  {
    word:"one",
    sentence:"I have one wish."
  },{
  word:"said",
  sentence:"Dad said hi!"
},{
word:"like",
sentence:"I like Bluey."
},
  {
    word:"my",
    sentence:"Gekko is my favorite."
  },
  {
    word:"this",
    sentence:"This is Halloween!"
  },{
  word:"help",
  sentence:"I will help mom."
},{
word:"of",
sentence:"I want a box of candy."
},
  {
    word:"you",
    sentence:"Will you go with me?"
  },

  {
    word:"as",
    sentence:"I was dressed as a wolf."
 
  },
  {
    word:"does",
    sentence:"Mommy does yoga."
  },{
  word:"by",
  sentence:"I like videos by Miss Linky."
},{
word:"she",
sentence:"She is happy."
},
  {
    word:"has",
    sentence:"Dad has video games."
  },
  {
    word:"good",
    sentence:"We are good listeners."
  },{
  word:"little",
  sentence:"I am mommy's little man."
},{
word:"and",
sentence:"Me and my brother love Halloween. "
},
  {
    word:"he",
    sentence:"He said thank you."
  },


  {
    word:"with",
    sentence:"I like Peanut Butter with Jelly."
  },{
  word:"have",
  sentence:"I have fun toys."
},{
word:"what",
sentence:"What are we having for dinner?"
},
  {
    word:"do",
    sentence:"What do you like?"
  },
  {
    word:"look",
    sentence:"I look great."
  },{
  word:"where",
  sentence:"Where are we going?"
},{
word:"me",
sentence:"Will you play with me?"
},
  {
    word:"a",
    sentence:"I want a pony."
  },
  {
    word:"was",
    sentence:"I was hungry."
  },{
  word:"his",
  sentence:"We played with his toys."
},{
word:"from",
sentence:"I am from the USA."
},
  {
    word:"we",
    sentence:"We played soccer."
  },
  {
    word:"want",
    sentence:"I want a bike."
  },{
  word:"go",
  sentence:"I will go to bed."
},{
word:"who",
sentence:"Who is that?"
},
  {
    word:"too",
    sentence:"I like witches too!"
  },
]


export default Words;